:host {
  display: block;
}

.mo-powerpay {
  font-family: 'Benton-Bold';
  width: 100%;
  border-radius: 40px;
  background: #AD38FF;
  display: flex;
  color: #ffffff;
  justify-content: center;
  align-items: center;
  max-width: 360px;
  padding: 15px 20px;
  cursor: pointer;
}

.mo-pay-later img {
  width: auto;
  margin: 0 auto;
  height: 10px;
}

h5 {
  margin: 0;
  font-size: 14px;
}

@media (max-width: 768px) {
  .mo-pay-later {
    width: inherit;
    max-width: 100%;
  }
}